import { useState, useEffect } from 'react';
import config from '../config';

import { Zap, Sliders, X } from 'lucide-react';

export const PowerFilter = ({ onFilterChange, initialValues }) => {
  const [minPower, setMinPower] = useState(initialValues?.min_power || '');
  const [maxPower, setMaxPower] = useState(initialValues?.max_power || '');
  const [brand, setBrand] = useState(initialValues?.brand || '');
  const [brands, setBrands] = useState([]);
  const [powerOptions, setPowerOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // دریافت لیست برندها و محدوده توان از API
  useEffect(() => {
    const fetchFilterOptions = async () => {
      setLoading(true);
      try {
        const response = await fetch(config.getApiUrl('/products/products/filter-options/'));
        if (response.ok) {
          const data = await response.json();
          setBrands(data.brands || []);
          setPowerOptions(data.power_ranges || [
            { label: '5 کیلووات', min: 5, max: 5 },
            { label: '6 کیلووات', min: 6, max: 6 },
            { label: '8 تا 10 کیلووات', min: 8, max: 10 },
            { label: '10 کیلووات', min: 10, max: 10 },
            { label: '15 کیلووات', min: 15, max: 15 },
            { label: '20 کیلووات', min: 20, max: 20 },
            { label: 'بیش از 20 کیلووات', min: 20, max: 100 },
            { label: 'بیش از 20 کیلووات', min: 20, max: 100 },
          ]);
        }
      } catch (error) {
        console.error('Error fetching filter options:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFilterOptions();
  }, []);

  const applyFilter = () => {
    onFilterChange({
      min_power: minPower,
      max_power: maxPower,
      brand: brand,
    });
  };

  const clearFilters = () => {
    setMinPower('');
    setMaxPower('');
    setBrand('');
    onFilterChange({});
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Zap className="w-5 h-5 text-yellow-500" />
        <h3 className="font-bold text-gray-900">فیلتر هوشمند بر اساس توان</h3>
      </div>

      {/* انتخاب سریع توان */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          توان مصرفی مورد نیاز
        </label>
        <div className="flex flex-wrap gap-2">
          {powerOptions.map((option) => (
            <button
              key={option.label}
              onClick={() => {
                setMinPower(option.min);
                setMaxPower(option.max);
                applyFilter();
              }}
              className={`px-3 py-1 rounded-full text-sm transition ${
                Number(minPower) === option.min && Number(maxPower) === option.max
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {/* محدوده توان دستی */}
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            حداقل توان (کیلووات)
          </label>
          <input
            type="number"
            step="0.5"
            value={minPower}
            onChange={(e) => setMinPower(e.target.value)}
            placeholder="مثال: 5"
            className="w-full border border-gray-300 rounded-lg px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            حداکثر توان (کیلووات)
          </label>
          <input
            type="number"
            step="0.5"
            value={maxPower}
            onChange={(e) => setMaxPower(e.target.value)}
            placeholder="مثال: 10"
            className="w-full border border-gray-300 rounded-lg px-3 py-2"
          />
        </div>
      </div>

      {/* فیلتر برند */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          برند
        </label>
        <select
          value={brand}
          onChange={(e) => setBrand(e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-3 py-2"
        >
          <option value="">همه برندها</option>
          {loading ? (
            <option disabled>در حال بارگذاری...</option>
          ) : (
            brands.map((b) => (
              <option key={b} value={b}>{b}</option>
            ))
          )}
        </select>
      </div>

      {/* دکمه‌ها */}
      <div className="flex gap-3">
        <button
          onClick={applyFilter}
          className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2"
        >
          <Sliders className="w-4 h-4" />
          اعمال فیلتر
        </button>
        <button
          onClick={clearFilters}
          className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center gap-1"
        >
          <X className="w-4 h-4" />
          پاک کردن
        </button>
      </div>
    </div>
  );
};